; (function () {
	"use strict";

	function RelatedPostsCards() {
		var fn = {
			init: function () {
				fn.setupCards();
				fn.bindResize();
			},

			setupCards: function() {
				var cardGrids = jQuery('.related-posts .related-posts__grid');

				if (!cardGrids.length) {
					return;
				}

				cardGrids.each(function(i, cardGrid) {
					fn.equaliseHeights(jQuery(cardGrid));
				});
			},

			equaliseHeights: function(cardGrid) {
				var titles = cardGrid.find('.cis-post-card__title');

				if (!titles.length) {
					return;
				}

				titles.each(function(i, title) {
					jQuery(title).css('min-height', '');
				});

				var largestTitleHeight = fn.getLargestHeight(titles);

				titles.each(function(i, title) {
					jQuery(title).css('min-height', largestTitleHeight);
				});
			},

			getLargestHeight: function(elems)
			{
				var largest = 0;
				elems.each(function(i, elem) {
					var elemHeight = jQuery(elem).height();
					if (elemHeight > largest)
					{
						largest = elemHeight;
					}
				});

				return largest;
			},

			bindResize: function() {
				jQuery(window).on('resize orientationchange', function() {
					fn.setupCards();
				});
			}
		};

		jQuery(document).ready(fn.init);
	}

	new RelatedPostsCards();
})();
